<template>
    <div class="weekday-picker">
        <button v-for="day in days" :key="day.value" type="button" class="weekday-pick"
            :class="{ on: value.includes(day.value) }" @click="toggle(day.value)">
            {{ day.name }}
        </button>
    </div>
</template>

<script>
export default {
    name: 'WeekdayPicker',
    props: {
        value: {
            type: Array,
            default: () => [],
        },
    },
    computed: {
        days(vm = this) {
            return [
                { name: vm.$t('common.short_monday'), value: 1 },
                { name: vm.$t('common.short_tuesday'), value: 2 },
                { name: vm.$t('common.short_wednesday'), value: 3 },
                { name: vm.$t('common.short_thursday'), value: 4 },
                { name: vm.$t('common.short_friday'), value: 5 },
                { name: vm.$t('common.short_saturday'), value: 6 },
                { name: vm.$t('common.short_sunday'), value: 0 },
            ]
        },
    },
    methods: {
        toggle(day) {
            const vm = this
            const next = vm.value.includes(day) ? vm.value.filter(item => item !== day) : [...vm.value, day]
            vm.$emit('input', next)
        },
    },
}
</script>

<style scoped>
.weekday-picker {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
}

.weekday-pick {
    min-width: 38px;
    height: 32px;
    padding: 0 8px;
    border-radius: 8px;
    border: 1px solid var(--v-outline-base);
    background: var(--v-surface2-base);
    color: var(--v-txtSecondary-base);
    font-size: 12px;
    font-weight: 600;
    cursor: pointer;
    transition: all .15s;
}

.weekday-pick.on {
    background: rgba(51, 153, 153, .15);
    border-color: var(--v-accent-base);
    color: var(--v-accent-base);
}
</style>
